import React, { useEffect, useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'; 
import { ClientInvestmentDetail } from "./models/ClientModel";

function ClientInvestmentGrid(props) {
  const [getClientInvestment, setClientInvestment] = useState([]);

  const columns = [
    {
      name:<div className="titlename"><span>Client Company Type</span></div> ,
      selector: row => row.ClientCompanyTypeName,
      cell: (row) => (
        <span title={row.ClientCompanyTypeName}>{row.ClientCompanyTypeName}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name:<div className="titlename"><span>Client Company</span></div> ,
      selector: row => row.ClientCompanyName,
      cell: (row) => (
        <span title={row.ClientCompanyName}>{row.ClientCompanyName}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          <Link
            className="confirm-text p-2"
            to=""
            onClick={() => {
              props.onDelete(row);
            }}
          >
            <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
          </Link>
        </div>
      ),
      center: "true",
      width: "150px"
    },
  ];
  useEffect(() => {
    setClientInvestment(props.ClientInvestmentData !== undefined ? props.ClientInvestmentData : []);
  }, [props.ClientInvestmentData]);
  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={getClientInvestment}
            sortIcon={<SortArrow/>}
            persistTableHead={true}
          />
        </div>
      </div>
      
    </>
  );
}

export default ClientInvestmentGrid;
